<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h2 id="landcover">2. Land Cover and Land Use</h2>
      </div>
    </div>



    <div class="row">
      <div class="col">
        <h3 >2.1. Land Cover</h3>
        <p>
          According to the WorldCover land cover dataset, the most dominant 
          land cover types in the 2021 were <span v-html="landCoverMain" />
        </p>
        <p>
          The degree of urbanization is extracted from the Global Human Settlement Layers 
          (GHSL) by JRC, and classified this mountain range as 

          <strong>{{ 100 * (factsheet.data.mountain_summary.ghs_smod.classes_simple['3'] / factsheet.data.mountain_summary.ghs_smod.ghs_smod_total_area) | percent }} urban centre</strong>, 
          <strong>{{ 100 * (factsheet.data.mountain_summary.ghs_smod.classes_simple['2'] / factsheet.data.mountain_summary.ghs_smod.ghs_smod_total_area) | percent }} urban cluster</strong>, and 
          <strong>{{ 100 * (factsheet.data.mountain_summary.ghs_smod.classes_simple['1'] / factsheet.data.mountain_summary.ghs_smod.ghs_smod_total_area) | percent }} rural areas</strong>.
          
        </p>
      </div>
    </div>



    <div class="row">
      <div class="col col-8">
        <ImageMap 
          title="Land Cover Map from 2021" 
          v-bind:images="[{title:'test',source:'/mountain_summary/Landcover.png'}]" 
          v-bind:location="location"
          v-bind:factsheet="factsheet" 
          v-bind:loaded="loaded"
          attribution="Data: WorldCover.">
        </ImageMap>
      </div>
      <div class="col col-4">
 <Figure 
          title="Land Cover Percentages" 
          src="mountain_summary/Landcover.svg"
          label="Land cover percentages for the 8 larges land cover classes found in the area." 
          attribution="Data: GHS-POP."

          v-bind:location="location"
          v-bind:factsheet="factsheet" 
          v-bind:loaded="loaded"
          >
        </Figure>
      </div>
    </div>



    

    <div class="row">
      <div class="col">
        <h3 >2.2. Land Cover Change</h3>
        <p>
          The following table shows a land cover change matrix for this mountain range, based on the data from the ESA Climate Change Initiative (CCI)
        </p>
      </div>
    </div>

    <LandDegradationNeutrality v-if="ldr" v-bind:location="location" v-bind:factsheet="factsheet" v-bind:ldr="ldr" v-bind:loaded="loaded" warning="no" ldrForceFormat="km2" ldrDisplay="table" />


  </div>
</template>

<script>
    /* eslint-disable */
    import ImageMap from '@/components/factsheet/maps/ImageMap.vue'
    import LandDegradationNeutrality from '@/components/factsheet/LandDegradationNeutrality.vue'
    import Figure from '@/components/factsheet/Figure.vue'

    import _ from 'lodash';

    export default {
        name: 'Landcover',
        components: { ImageMap, LandDegradationNeutrality, Figure },
        props: ['location', 'factsheet', 'loaded'],
        data() {
            return {
            }
        },
        created() {
        },
        computed: {
          ldr() {
            if(this.loaded && this.factsheet.data["land_degradation_neutrality"]) {
              return this.factsheet.data["land_degradation_neutrality"]
            } else {
              return null;
            }
          },
          landCoverMain() {
            var landCoverTot = 0;
            var landCoverList = [];
            for(var i=0; i<this.factsheet.data.mountain_summary.landcover_classes.length;i++) {
              var lc = this.factsheet.data.mountain_summary.landcover_classes[i];
              if(landCoverTot <= 90) {
                landCoverTot += lc["percent"]
                landCoverList.push(lc);
              }
            }
            function fmt(value) {
              return "<strong>"+value['title'].toLowerCase()+"</strong>" + " (<strong>"+value['percent'].toFixed(1)+"%</strong>)"
            }
            return this.andListFmt(landCoverList, fmt)+"."
          }
        },
        mounted() {
        },
        filters: {
          percent: function (value) {
            return value.toFixed(1)+'%'
          }
        },
        methods: {
          urlFor(asset) {
            return process.env.VUE_APP_API+'/api/data/factsheet/'+this.factsheet.info.identifier+'/data/'+asset;
          },
          andList(list, attr, attrpercent) {
            var ret = ""
            for(var i=0; i<list.length;i++) {
              var percent = attrpercent ? ' ('+list[i][attrpercent]+'%)' : ''
              if (list.length == 1) {
                return list[i][attr]+percent
              }
              if(i == list.length-1) {
                ret += " and "+list[i][attr]+percent
              } else {
                ret += list[i][attr]+percent+", "
              }
            }
            return ret
          },
          andListFmt(list, formatter) {
            var ret = ""
            for(var i=0; i<list.length;i++) {
              //var percent = attrpercent ? ' ('+list[i][attrpercent]+'%)' : ''
              if (list.length == 1) {
                return formatter(list[i])
              }
              if(i == list.length-1) {
                ret += " and "+formatter(list[i])
              } else {
                ret += formatter(list[i])+", "
              }
            }
            return ret
          }
        }
    }
</script>

<style>
div.map {
    width:100%;
    height:450px;
    display:block;
}
</style>

<style scoped>

caption {
  caption-side: top;
  font-weight:bold;
  font-size:1em;
  padding:5px;
  color:rgb(33, 37, 41);
  padding-left:0px;
}
table {
   font-size:0.75em;
}
table th, table td {
  padding-left:0px;
}

</style>